import React, { FC, useState } from "react";
import { useIntl } from "react-intl";
import { formatPrice } from "../../../selectors";
import { HeaderModel } from "../../../models/CommonModel";
import SortableColumn from "../../../components/Table/SortableColumn";
import { ImportRequestDetailModel } from "../../../models/ImportRequestModel";
import moment from "moment";

interface IRow {
    item: ImportRequestDetailModel
}

type Props = {
    data: Array<ImportRequestDetailModel>,
    header: HeaderModel[],
    hideCols: string[],
    openColConfig: () => void,
    handleSort: (sortBy: string, direction: 'asc' | 'desc' | 'none') => void
};
const ImportRequestHistTable: FC<Props> = ({ data, header, hideCols, openColConfig, handleSort }) => {

    const intl = useIntl();

    const Row: FC<IRow> = ({ item }) => {
        let approvedAt = item?.import_request?.approved_at ? moment(item.import_request.approved_at).format('DD-MM-YYYY') : ''
        return (
            <tr key={`detail_${item.id}`} className={`cursor-pointer`}>
                {!hideCols.includes('name') && (
                <td>
                    {item?.product?.name ?? ''}
                </td>
                )}
                {!hideCols.includes('store') && (
                <td>
                    {item?.import_request?.store?.name ?? ''}
                </td>
                )}
                {!hideCols.includes('price') && (
                <td >
                    {formatPrice(item?.unit_price ?? 0)}
                </td>
                )}
                {!hideCols.includes('quantity') && (
                <td className="">
                    <div className="input-group input-group-sm mb-3 ">
                    {item?.quantity ?? 0}   
                    </div>
                </td>
                )}
                {!hideCols.includes('vat') && (
                <td>
                    <div className="input-group input-group-sm mb-3 ">
                    {item?.vat ?? 0}%
                    </div>
                </td>
                )}
                {!hideCols.includes('approved_at') && (
                <td>
                    { approvedAt }
                </td>
                )}
            </tr>
        )
    }

    return <>
        <div className='table-responsive'>
            <table className="table table-hover table-bordered table-striped border gy-7 gs-7">
                <thead>
                    <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                        {header.map((th, index) => {
                            if (!hideCols.includes(th.field)) {
                                if (th.sortable) {
                                    return (
                                        <SortableColumn
                                            key={'th-' + index}
                                            keyVal={'th-' + index}
                                            sortBy={th?.field}
                                            onSortChange={handleSort}
                                            style={th?.style ?? {}}
                                        >
                                            {th.label}
                                        </SortableColumn>
                                    )
                                }
                                return (
                                    <th data-key={'th-' + index} key={'th-' + index} style={th?.style ?? {}}>{th.label}</th>
                                )
                            }
                        })}
                    </tr>
                </thead>
                <tbody>
                    {data?.map((item: ImportRequestDetailModel) => <Row key={item.id} item={item} />)}
                </tbody>
            </table>
        </div>
    </>
}
export default ImportRequestHistTable;